// extracted by mini-css-extract-plugin
module.exports = {"ModalContainer":"Table_ModalContainer__SRaRp","TableHeader":"Table_TableHeader__XjRjQ"};